import React from 'react';
import App, { AppContext } from 'next/app';

function CustomApp({ Component, pageProps }) {
  return <Component {...pageProps} />;
}

CustomApp.getInitialProps = async (appContext: AppContext) => {
  const appProps = await App.getInitialProps(appContext);
  return { ...appProps };
};

export default CustomApp;
